module.exports = __webpack_public_path__ + "img/lieu agence.064906fb.png";